/* Shop All UGC1 — dedicated review gallery. Pulls curated UGC media from CakeTrack
   and renders a horizontal scroll of photo cards that each link to their product. */
(function () {
  var R = window.SaUgc1Reviews;
  var el = document.querySelector('[data-sa-ugc-gallery]');
  if (!R || !el) return;
  var CAP = 10;

  R.getShopAll(CAP).then(function (out) {
    var section = el.closest('.sa-ugc-sec');
    if (!out.length) { if (section) section.style.display = 'none'; return; }
    el.innerHTML = out.map(function (o) {
      var rv = o.rv;
      var q = R.cleanQuote(rv.review_text, 52);
      var open = o.handle ? '<a class="sa-ugc" href="/products/' + R.esc(o.handle) + '">' : '<span class="sa-ugc">';
      var close = o.handle ? '</a>' : '</span>';
      return open +
        '<img src="' + R.esc(rv.photo_urls[0]) + '" alt="" loading="lazy">' +
        '<span class="sa-ugc-cap">' +
          '<span class="sa-ugc-stars" aria-hidden="true">★★★★★</span>' +
          (q ? '<span class="sa-ugc-q">“' + R.esc(q) + '”</span>' : '') +
          '<span class="sa-ugc-name"><span class="sa-ugc-vb">✓ Verified</span>' + R.esc(window.transformReviewName(rv.reviewer_display_name, 'Buyer')) + '</span>' +
        '</span>' + close;
    }).join('');
  });
})();
